module.exports = __webpack_public_path__ + "img/hms-belfast-website-thumbnail.a209e05b.jpg";